import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { games as gamesApi } from '../services/api';
import GameCard from '../components/GameCard';

const GameLibrary = () => {
  const [games, setGames] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    fetchGames();
  }, []);

  const fetchGames = async () => {
    try {
      const response = await gamesApi.getGamesByCategory();
      setGames(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch games:', error);
      setLoading(false);
    }
  };

  const handleGameClick = (game) => {
    // Check if the game is free based on the premium flag
    if (game.premium && !user.subscription) {
      navigate('/subscription');
      return;
    }
    
    // Special handling for free games
    switch (game.id) {
      case '1.1': // 2048
        navigate('/games/2048');
        break;
      case '1.2': // Memory Match
        navigate('/games/MemoryMatch');
        break;
      case '1.3': // XOGame
        navigate('/games/XOGame');
        break;
      case '1.4': // Sudoku
        navigate('/games/SudokuGame');
        break;
      case '1.5': // Chess
        navigate('/games/chess');
        break;
      default:
        navigate(`/stream/${game.id}`);
    }
  };

  const filteredGames = games.map(category => ({
    ...category,
    games: category.games.filter(game =>
      game.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      game.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.games.length > 0);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-purple-900 flex items-center justify-center">
        <p className="text-white text-xl">Loading games...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-purple-900 flex flex-col">
      {/* Fixed Header */}
      <header className="sticky top-0 z-10 bg-gray-900 bg-opacity-90 backdrop-filter backdrop-blur-sm py-4 px-8 shadow-lg">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <h1 className="text-3xl font-bold text-white">Web Arcade</h1>
          <input
            type="text"
            placeholder="Search games..."
            className="pl-4 pr-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-purple-500 w-64 text-white placeholder-gray-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow p-8 pt-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid gap-8">
            {filteredGames.map((category) => (
              <div key={category.id}>
                <h2 className="text-2xl font-semibold text-white mb-4">
                  {category.category} Games
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {category.games.map((game) => (
                    <GameCard
                      key={game.id}
                      game={game}
                      onClick={() => handleGameClick(game)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default GameLibrary;